import useJwt from '@/auth/jwt/useJwt'
import ability from '@/libs/acl/ability'
import axios from 'axios'

export const urlHasToken = () => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)

    const token = urlParams.get('token')

    if (!token) return null

    const cleanedToken = token.split('|')[1] ?? null

    return cleanedToken
}

export const getTokenValidationUrl = () => {
    return `${process.env.VUE_APP_API_URL}/auth/validate`
}

export const fetchValidateToken = async () => {
    if (process.env.VUE_APP_VALID_TOKEN === 'false') {
        return
    }

    const isDataFastCallback = window.location.pathname === '/datafast-callback'
    if (isDataFastCallback) {
        return
    }

    const accessToken = await localStorage.getItem('accessToken')

    if (!accessToken) {
        return
    }

    const token = accessToken.split('|')[1]
        ? accessToken.split('|')[1]
        : accessToken

    if (!token) {
        return
    }

    const url = await getTokenValidationUrl()

    axios
        .get(url, {
            params: {
                token,
                device_name: 'web',
            },
        })
        .then((response) => {
            useJwt.setToken(response.data.accessToken)
            useJwt.setRefreshToken(response.data.accessToken)

            localStorage.setItem(
                'userData',
                JSON.stringify(response.data.userData)
            )

            ability.update(response.data.userData.ability)
        })
        .catch(() => {
            // Token validation error - session remains intact
            // Router guard or backend will handle invalid token
        })
}
